import { Component } from '@angular/core';
@Component({
  selector: 'app-device-admin',
  templateUrl: './device-admin.component.html',
  styleUrls: ['./device-admin.component.scss'],
  standalone: false,
})
export class DeviceAdminComponent {}
